export const NOTIFICATIONS_SECTION_ID = "notifications" as const;
export const NOTIFICATIONS_SECTION_ORDER = 50;
